/* ==========================================================================
   VeteNa · Vistos recientemente
   Guarda el historial de fichas visitadas en localStorage (solo en este
   navegador) y rellena la sección con las tarjetas de esos productos,
   pedidas vía Section Rendering API para que se vean igual que en el
   resto de la tienda.
   Archivo: assets/vetena-recently-viewed.js
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'vetena_recently_viewed';
  var MAX_STORED = 24; // tope del historial guardado en el navegador

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) {
      // localStorage puede fallar (modo privado, cookies bloqueadas...).
      // Sin historial no pasa nada grave: la sección simplemente no se muestra.
      return [];
    }
  }

  function writeHistory(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (err) {
      /* ver nota de arriba */
    }
  }

  function recordView(handle) {
    if (!handle) return;
    var list = readHistory().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    if (list.length > MAX_STORED) list.length = MAX_STORED;
    writeHistory(list);
  }

  function fetchCard(handle) {
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=vetena-viewed-card';
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('vetena-recently-viewed: producto no disponible (' + handle + ')');
        return res.text();
      })
      .then(function (html) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        return wrapper.querySelector('.vetena-recently-viewed__item');
      })
      .catch(function () {
        // Producto borrado, despublicado o de error: se descarta en silencio,
        // igual que haría cualquier carrusel de recomendaciones.
        return null;
      });
  }

  function init(section) {
    if (section.dataset.vetenaReady === 'true') return;
    section.dataset.vetenaReady = 'true';

    var currentHandle = section.dataset.currentHandle;
    var maxItems = parseInt(section.dataset.maxItems, 10) || 4;
    var list = section.querySelector('[data-vetena-recently-viewed-list]');
    if (!list) return;

    // Registra la visita actual ANTES de pedir el historial, para que quede
    // guardada aunque la persona no llegue a ver ningún producto todavía.
    recordView(currentHandle);

    var toShow = readHistory()
      .filter(function (h) {
        return h !== currentHandle;
      })
      .slice(0, maxItems);

    if (toShow.length === 0) return; // la sección se queda oculta

    Promise.all(toShow.map(fetchCard)).then(function (items) {
      var valid = items.filter(Boolean);
      if (valid.length === 0) return;
      valid.forEach(function (item) {
        list.appendChild(item);
      });
      section.hidden = false;
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-vetena-recently-viewed]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Recarga al volver a un producto con la sección ya en el DOM (editor de
  // temas, o navegación instantánea si el tema la usa).
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
